import React, {
  FunctionComponent, useEffect, useState,
} from 'react';
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';
import { ReactComponent as AnnouncementIcon } from '../assets/announcement-icon.svg';
import CcsV2FeatureAnnouncement from './v2/ccsv2-feature-announcement';
import { Tooltip } from '.';
import { showAnnouncementButton, clearFeatureSetFromLocalStorage } from '../services';
import { useAppState } from '../hooks';

const AnnouncementButtonWrapper = styled(Box)`
  position: absolute;
  bottom: 72px;
  left: 14px;
  `;

const AnnouncementButtonContainer = styled(Box)`
  width: 32px;
  height: 32px;
  border-radius: ${(props) => props.theme.radius.biggest};
  &:hover {
    cursor: pointer;
    background: ${(props) => props.theme.colors.ghostLight}
  }
`;

const AnnouncementButton: FunctionComponent = () => {
  const [showAnnouncementBanner, setShowAnnouncementBanner] = useState(false);
  const { features, isCcsV2 } = useAppState();

  const showBanner = () => {
    clearFeatureSetFromLocalStorage();
    setShowAnnouncementBanner(true);
  };

  const closeBanner = () => {
    setShowAnnouncementBanner(false);
  };

  const announcementButton = (
    <AnnouncementButtonContainer>
      <AnnouncementIcon />
    </AnnouncementButtonContainer>
  );

  return (showAnnouncementButton(features, { isCcsV2 }) ? (
    <>
      <AnnouncementButtonWrapper onClick={showBanner}>
        <Tooltip position="right" arrow="center" parent={announcementButton}>
          What&apos;s new
        </Tooltip>
      </AnnouncementButtonWrapper>
      { showAnnouncementBanner && <CcsV2FeatureAnnouncement closeBanner={closeBanner} />}
    </>
  ) : null
  );
};

export default AnnouncementButton;
